import TouristContainer from "../../container/TouristContainer";
import Headings from "../../container/Headings";
import Footer from "../../components/Footer";
import vivanta from '../../assets/hotels/vivanta.jpeg'
import Residency from '../../assets/hotels/residency.jpg'
import Lemeredian from '../../assets/hotels/lemeredian.jpg'
import Radisson from '../../assets/hotels/raddisson.jpg'
import hashsix from '../../assets/hotels/hashsix.jpg'
import lemon from '../../assets/hotels/lemon.jpg'

import cag from '../../assets/hotels/cag.jpg'
import citytower from '../../assets/hotels/citytower.jpg'
import alankar from '../../assets/hotels/alankar.jpg'
import farfield from '../../assets/hotels/farfield.jpg'
import welcome from '../../assets/hotels/welcome.jpeg'
import kiscol from '../../assets/hotels/kiscol.jpeg'
import rathna from '../../assets/hotels/rathna.avif'
import vijay from '../../assets/hotels/vijay.jpg'

import sri from '../../assets/hotels/sri.jpg'
import zone from '../../assets/hotels/zone.jpg'
import jothi from '../../assets/hotels/jothi.jpeg'

export default function HotelStay() {
  return (
    <main className=" mt-20">
      <p className=" text-2xl sm:text-4xl text-center font-bold uppercase py-10">
        Hotels for Stay
      </p>
      <p className=" pb-5 sm:text-xl text-lg text-center ">
        Participants are requested to book the accommodation well in advance
        through online booking. Some of the best hotels are listed below.
      </p>
      <div className=" flex flex-col justify-center items-center place-self-center">
        <Headings text="Luxury Hotels" />
        <div className=" grid  xl:grid-cols-3  md:grid-cols-2 gap-14 mt-10 mx-auto">
          <TouristContainer
            name={"Vivanta, Race Course Road, Coimbatore"}
            img={vivanta}
          />
          <TouristContainer
            name={"The Residency Towers, Avinashi Road Coimbatore"}
            img={Residency}
          />
          <TouristContainer
            name={"Le Meridien, Neelambur, Coimbatore"}
            img={Lemeredian}
          />
          <TouristContainer
            name={"Radisson Blu, Avinashi Road Coimbatore"}
            img={Radisson}
          />
          <TouristContainer
            name={"Hash Six Hotel, Saibaba Colony, Coimbatore"}
            img={hashsix}
          />
          <TouristContainer
            name={"Lemon Tree Hotel, Coimbatore"}
            img={lemon}
          />
        </div>
      </div>

      <div className=" flex flex-col justify-center my-20 items-center place-self-center">
        <Headings text="Mid-Range Hotels" />
        <div className=" grid xl:grid-cols-3  md:grid-cols-2 gap-14 mt-10 mx-auto">
          <TouristContainer
            name={"Hotel CAG Pride, Gandhipuram, Coimbatore"}
            img={cag}
          />
          <TouristContainer
            name={"City Tower, Gandhipuram, Coimbatore"}
            img={citytower}
          />
          <TouristContainer
            name={"Hotel Alankar, Gandhipuram, Coimbatore"}
            img={alankar}
          />
          <TouristContainer
            name={"Fairfield by Marriott, Avinashi Road, Coimbatore"}
            img={farfield}
          />
          <TouristContainer
            name={"Welcomhotel, ITC Hotels, Race Course, Coimbatore"}
            img={welcome}
          />
          <TouristContainer
            name={"Hotel KISCOL Grands, Ramnagar, Coimbatore"}
            img={kiscol}
          />
        
          <TouristContainer
            name={"Rathna Residency, Town Hall, Coimbatore"}
            img={rathna}
          />
          <TouristContainer
            name={"Hotel Vijay Park Inn, Ramnagar, Coimbatore"}
            img={vijay}
          />
         
        </div>
      </div>

      <div className=" flex flex-col justify-center my-20 items-center place-self-center">
        <Headings text="Budget-Friendly Hotels" />
        <div className=" grid xl:grid-cols-3 md:grid-cols-2 gap-14 mt-10 mx-auto">
          <TouristContainer
            name={"Sri Aarvee Hotels, Gandhipuram, Coimbatore"}
            img={sri}
          />
          <TouristContainer
            name={"Zone by The Park, Coimbatore"}
            img={zone}
          />
          <TouristContainer
            name={"Hotel Jothi Grand, Near KCT, Saravanampatti, Coimbatore"}
            img={jothi}
          />
        </div>
      </div>

      <p className=" text-center text-lg px-3">For more hotels, visit <a className=" text-primary-blue hover:underline underline-offset-2 font-semibold" href="https://shorturl.at/VgNzo" target="_blank">here</a></p>

      <Footer />
    </main>
  );
}
